module.exports = __webpack_public_path__ + "img/Modernisme_Tida_og_samfunnsforholdene1.61a460ca.jpg";